<template>

  <div
    class="card"
    :class="{'box-loading': loading}">
    <table
      class="table mb-0"
      :class="{'table-hover': allPlacement}">
      <tbody>
        <tr 
          v-for="(item, index) in placementFiltered"
          :key="index">
          <td
            @click="selectCandidateJob(item.job_id._id)"
            :style="{'cursor': allPlacement ? 'pointer' : 'default'}">
            <div>
              <PointStatus :status="item.job_id.status" />
              <span @click="$event.stopPropagation()">
                <router-link :to="{path: '/job/' + item.job_id._id}" v-on:click.stop="">{{ item.job_id.title }}</router-link>
                <span class="text-muted">#{{ item.job_id.code }}</span>
              </span>
            </div>
            <div>
              <small>
                <span v-if="item.job_id.company_id">{{ item.job_id.company_id.name }},</span>
                <span v-if="item.job_id.departament_id">{{ item.job_id.departament_id.name }}</span>
              </small>
            </div>
          </td>
          <td width="50">
            <CandidatePlacementsStatus
              :placement_id="item._id"
              :status="item.status"
              :stage_id="item.stage_id"
              :jobStages="item.job_id.stages"
              @changed="loadData" />
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="permissions.includes('manage_candidates') && allPlacement">
      <SelectJob 
        @input="insertPlacement"
        :disconsiderIds="currentJobsIds"
        :filters="{status: 'open'}"
        :placeholder="$t('Assign to new job')" />
    </div>
    
    <div
      class="card-footer"
      style="border-top: 0">
      
      <button
        style="float:right"
        type="button"
        class="btn btn-sm"
        @click="allPlacement = !allPlacement">
        {{ $t('Select job') }} <span v-if="placementsDetail.length">({{ placementsDetail.length }})</span>
        </button>

      <label
        v-if="selectedJob"
        class="btn btn-sm m-0">
        <input
          type="checkbox"
          :checked="onlyThisJob"
          @click="changeOnlyPlacement">
          {{ $t('Activities only for this job') }}
        </label>

    </div>

  </div>

</template>

<script>
import SelectJob from '@/components/Fields/SelectJob'
import PointStatus from '@/components/Parts/PointStatus'
import CandidatePlacementsStatus from './CandidatePlacementsStatus'

export default {
  name: 'CandidatePlacements',
  components: {
    SelectJob,
    CandidatePlacementsStatus,
    PointStatus
  },
  props: [
  ],
  data () {
    return {
      loading: false,
      allPlacement: false,
      jobs: {},
      placementsDetail: []
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    },
    placementFiltered () {
      return this.placementsDetail.filter(placement => {
        return this.allPlacement || (this.selectedJob && this.selectedJob._id === placement.job_id._id)
      })
    },
    currentJobsIds () {
      return this.placementsDetail.map(item => {
        return item.job_id._id
      })
    },
    hasJobs () {
      return this.candidate.placements.length
    }
  },
  created () {
    if (this.hasJobs) {
      this.loadData()
    }
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.$store.dispatch('getPlacementsDetail', {
        candidate_id: this.candidate._id
      }).then(docs => {
        this.placementsDetail = docs
        this.loading = false
      })
    },
    /*
    selectCandidateJob
    */
    selectCandidateJob (jobId) {
      this.allPlacement = false

      this.$changeUrlParam({
        candidate_job_id: jobId
      })
    },
    /*
    changeOnlyPlacement
    */
    changeOnlyPlacement (event) {
      this.$changeUrlParam({
        candidate_only_this_job: event.target.checked ? 1 : null
      })
    },
    /*
    insertPlacement
    */
    insertPlacement (jobId) {
      this.loading = true

      return this.$store.dispatch('createPlacement', {
        candidate_id: this.candidate._id,
        job_id: jobId
      }).then(placement => {
        this.loading = false
        this.selectCandidateJob(placement.job_id)
        this.loadData()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Placements/CandidatePlacements.vue